import Vue from 'vue'

Vue.filter('formatDate', function(value) {
    return new Date(value).toLocaleString().replace(/,/, '')
})

Vue.filter('onlyDay', function(value) {
    if (!value) return '—'

    return new Date(value).format('{yyyy}-{MM}-{dd}')
})

Vue.filter('onlyTime', function(value) {
    if (!value) return '—'

    return new Date(value).format('%H:%M:%S')
})

Vue.filter('fullDate', function(value) {
    if (!value) return '—'

    return new Date(value).format('{dd}.{MM}.{yyyy} {HH}:{mm}:{ss}')
})
